import type { EmployerHiringUpdateFlowProps } from './EmployerHiringUpdateFlow.types';
import { PropsWithChildren } from 'react';
import { HiredSomeoneStep } from 'features/EmployerHiringUpdateFlow/steps/HiredSomeoneStep';
import { HaveYouHiredStep } from 'features/EmployerHiringUpdateFlow/steps/HaveYouHiredStep';
import { HiredHowStep } from 'features/EmployerHiringUpdateFlow/steps/HiredHowStep';
import { HiringMethodsStep } from 'features/EmployerHiringUpdateFlow/steps/HiringMethodsStep';
import { HiredMultipleTeachersToWhichRoleStep } from 'features/EmployerHiringUpdateFlow/steps/HiredMultipleTeachersToWhichRoleStep';
import { NotHiringReasonStep } from 'features/EmployerHiringUpdateFlow/steps/NotHiringReasonStep';
import { FeedbackStep } from 'features/EmployerHiringUpdateFlow/steps/FeedbackStep';
import { HiredWhoStep } from 'features/EmployerHiringUpdateFlow/steps/HiredWhoStep';
import { HiringUpdateFlowProvider } from 'features/EmployerHiringUpdateFlow/EmployerHiringUpdateContext';
import { NewHireConfirmationStep } from 'features/EmployerHiringUpdateFlow/steps/NewHireConfirmationStep';
import { FeedbackDeniedStep } from 'features/EmployerHiringUpdateFlow/steps/FeedbackDeniedStep';
import { FeedbackAddMoreStep } from 'features/EmployerHiringUpdateFlow/steps/FeedbackAddMoreStep';
import { HiredWhoElseStep } from 'features/EmployerHiringUpdateFlow/steps/HiredWhoElseStep';
import { HiredAdditionalTeachersToWhichRoleStep } from 'features/EmployerHiringUpdateFlow/steps/HiredAdditionalTeachersToWhichRoleStep';

export const EmployerHiringUpdateFlow = (
  props: PropsWithChildren<EmployerHiringUpdateFlowProps>,
) => {
  const { open, onClose, flowType, ...caseProps } = props;

  return (
    <HiringUpdateFlowProvider open={open} onClose={onClose} flowType={flowType} {...caseProps}>
      <NewHireConfirmationStep />
      <HiredSomeoneStep />
      <HaveYouHiredStep />
      <HiredHowStep />
      <HiredWhoStep />
      <HiredWhoElseStep />
      <HiringMethodsStep />
      <HiredMultipleTeachersToWhichRoleStep />
      <HiredAdditionalTeachersToWhichRoleStep />
      <NotHiringReasonStep />
      <FeedbackDeniedStep />
      <FeedbackAddMoreStep />
      <FeedbackStep />
    </HiringUpdateFlowProvider>
  );
};

EmployerHiringUpdateFlow.displayName = 'EmployerHiringUpdateFlow';
